import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/system';
import { useState } from 'react';

export default function DraggableCarousel({
  scrollSpeed = 1,
  children,
  sx,
  spacing = 0,
}: {
  scrollSpeed?: number;
  children: any;
  sx?: SxProps<Theme>;
  spacing?: number | string;
}) {
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  function dragHandler(e: any) {
    if (isDown) {
      e.preventDefault();
      const x = e.pageX - e.currentTarget.offsetLeft;
      const walkX = (x - startX) * scrollSpeed;
      e.currentTarget.scrollLeft = scrollLeft - walkX;
    }
  }

  return (
    <Box
      onMouseDown={(e: any) => {
        setIsDown(true);
        setStartX(e.pageX - e.currentTarget.offsetLeft);
        setScrollLeft(e.currentTarget.scrollLeft);
      }}
      onMouseUp={() => setIsDown(false)}
      onMouseLeave={() => setIsDown(false)}
      onMouseMove={dragHandler}
      display="flex"
      position="relative"
      width="100%"
      sx={{
        overflowX: 'scroll',
        scrollSnapType: isDown ? 'none' : 'x',
        '&:hover': { cursor: 'grab' },
        '&::-webkit-scrollbar': { display: 'none' },
        '&>*:not(:first-child):not(:last-child)': { mx: spacing },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
